const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { accordion } = require("./modules/accordion");

scrollmagic();
pageTop();
smooth();
accordion();
